export const kEmailContactStr = 'copywriterprofesional.negocio@gmail.com';